import moment from 'moment';

export const getOdocDateWithHourMin = date => moment(date).format('YYYY.MM.DD HH:mm');

export const getOdocDate = date => moment(date).format('YYYY.MM.DD');

export default {};
